module.exports = __webpack_public_path__ + "img/Nicole.7b74b08.png";